<template>
  <section class="price-compare">
    <div class="container">
      <SectionHeader title="Comparison of basic & Premium Pricing" />
      <div class="compare-list">
        <div
          class="list-content"
          v-for="(content, index) in compareData"
          :key="index"
        >
          <div class="list-title">
            <div class="title">
              {{ content.title }}
            </div>
            <div class="type" v-if="index === 0">
              <div class="icon-wrap">
                <img src="@/assets/icons/layers.svg" alt="basic" />
              </div>
              Basic
            </div>
            <div class="type" v-if="index === 0">
              <div class="icon-wrap">
                <img src="@/assets/icons/diamond.svg" alt="premium" />
              </div>
              Premium
            </div>
          </div>
          <div
            class="list-detail"
            v-for="(listitem, i) in content.list"
            :key="i"
          >
            <div class="detail title">
              {{ listitem.title }}
            </div>
            <div class="type">
              <div class="icon-wrap" :class="{ active: listitem.access.basic }">
                <img src="@/assets/icons/price-tick.svg" alt="steps" />
              </div>
            </div>
            <div class="type">
              <div
                class="icon-wrap"
                :class="{ active: listitem.access.premium }"
              >
                <img src="@/assets/icons/price-tick.svg" alt="steps" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SectionHeader from "@/pageComponents/globalUi/section-header";
import { athleteCompareData, clubCoachCompareData } from "./data";
export default {
  name: "PriceComparison",
  components: {
    SectionHeader
  },
  data() {
    return {
      athleteCompareData,
      clubCoachCompareData
    };
  },
  computed: {
    classObject() {
      return this.extraClass ? this.extraClass : "";
    },
    compareData() {
      return this.onlyPlayer()
        ? this.athleteCompareData
        : this.clubCoachCompareData;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variable.scss";
@import "@/scss/_mixins.scss";
.price-compare {
  .compare-list {
    .list-content {
      margin-bottom: 40px;
      > div {
        display: flex;
        flex-wrap: wrap;
        .title {
          width: 60%;
        }
        .type {
          width: 20%;
        }
      }
      .list-title {
        background: #2121640d;
        padding: 20px 25px;
        margin-bottom: 20px;
        font-family: $content-font;
        text-transform: uppercase;
        font-weight: 700;
        color: #212164;
        font-size: 20px;
        .type {
          display: flex;
          align-items: center;
          justify-content: center;
          .icon-wrap {
            width: 23px;
            margin-right: 10px;
          }
        }
      }
      .list-detail {
        padding: 10px 25px;
        .detail {
          font-family: $content-font;
          font-weight: 500;
          color: #707070;
          font-size: 16px;
        }
        .type {
          display: flex;
          justify-content: center;
          .icon-wrap {
            width: 23px;
            opacity: 0.3;
            &.active {
              opacity: 1;
            }
          }
        }
        &:first-child {
          padding-top: 0;
        }
        &:last-child {
          padding-bottom: 0;
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .price-compare {
    .compare-list {
      .list-content {
        .list-title {
          padding: 15px 20px;
          font-size: 16px;
          margin-bottom: 15px;
          .type {
            .icon-wrap {
              width: 18px;
            }
          }
        }
        .list-detail {
          padding: 8px 15px;
          .detail {
            font-size: 14px;
          }
          .type {
            .icon-wrap {
              width: 18px;
            }
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 425px) {
  .price-compare {
    .compare-list {
      .list-content {
        .list-title {
          padding: 10px 15px;
          font-size: 14px;
          margin-bottom: 10px;
          .type {
            .icon-wrap {
              display: none;
            }
          }
        }
        .list-detail {
          padding: 6px 15px;
          .detail {
            font-size: 12px;
          }
          .type {
            .icon-wrap {
              width: 14px;
            }
          }
        }
      }
    }
  }
}
</style>
